module.exports = "<div class=\"chart\">\n  <div [chart]=\"chartService.icuCharts.b2m.rr.chart\"></div>\n</div>"